import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useSearchResultBoxStyles = makeStyles<Theme, { isOnClickShouldPropagate: boolean }>({
  card: {
    padding: '8px 0',
    position: 'relative',
    cursor({ isOnClickShouldPropagate }) {
      return isOnClickShouldPropagate ? 'pointer' : undefined;
    }
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  grid: {
    maxWidth: '100%'
  },
  radio: {
    color: 'black !important'
  },
  content: {
    overflow: 'clip',
    paddingRight: '8px'
  }
});
